<template>

  <div v-if="propsMemberName" id="welcomeMsg" class="text-right">
    ようこそ！ <span class="font-weight-bold">{{propsMemberName}}</span> さん
  </div>

</template>

<script>
    //import mixin
    import common from '../../../mixins/common';

    //vue
    export default {
        mixins: [common],
        props:{
          propsMemberName: {
            type:String
          }
        },
        mounted() {
            console.log('HeaderLoginMessageComponent mounted.')
        }
    }
</script>
